import Backdrop from '@mui/material/Backdrop'
import React from 'react'
import LottieLoader from './LottieLoader'

export const LoadingFallback = () => {
  return (
    <Backdrop open={true} invisible>
      <LottieLoader />
    </Backdrop>
  )
}
